import { graphql, useStaticQuery } from "gatsby";
import React from "react";

const isExternalLink = (currentHostname: string, url: string) => {
  try {
    const link = new URL(url);
    return currentHostname !== link.hostname;
  } catch (e) {
    return true;
  }
};

export const renderMarkdownLink = ({ href, children }) => {
  const data: { site: { siteMetadata: { siteUrl: string } } } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `);

  const { hostname } = new URL(data.site.siteMetadata.siteUrl);

  return isExternalLink(hostname, href) ? (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ) : (
    <a href={href} target="_blank">
      {children}
    </a>
  );
};
